import { httpsCallable } from 'firebase/functions';
import { AxiosService } from '../../axios/axios.service';
import { tAxiosCustomConfig } from '../../axios/axios.types';
import { firebase } from '../../firebase/firebase.singleton';
import {
  tLeadbotChatbotResponse,
  tAutomationsResponse,
  tGetLeadbotStatusResponse,
  tLeadbotResponse,
  tGetLeadbotAutomationsResponse,
  tCreateLeadbotResponse,
  tUpdateLeadbotStatusResponse,
} from './LeadBot.types';

export const LeadbotService = {
  getLeadbotStatus: async function (
    wid: string,
  ): Promise<tLeadbotResponse<tGetLeadbotStatusResponse>> {
    try {
      const response = await AxiosService.get<
        tLeadbotResponse<tGetLeadbotStatusResponse>
      >(`/workspace/${wid}/leadbot`);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getLeadbotAutomations: async function (
    wid: string,
  ): Promise<tLeadbotResponse<tGetLeadbotAutomationsResponse>> {
    try {
      const response = await AxiosService.get<
        tLeadbotResponse<tGetLeadbotAutomationsResponse>
      >(`/workspace/${wid}/leadbot/automations`);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getLeadbotChatbot: async function (
    wid: string,
  ): Promise<tLeadbotResponse<tLeadbotChatbotResponse>> {
    try {
      const response = await AxiosService.get<
        tLeadbotResponse<tLeadbotChatbotResponse>
      >(`/workspace/${wid}/leadbot/chatbot`);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  createLeadbot: async function (
    wid: string,
    formData: tLeadbotChatbotResponse,
  ): Promise<tLeadbotResponse<{ data: tCreateLeadbotResponse }>> {
    try {
      const config: tAxiosCustomConfig = {
        headers: {},
        isLegacy: true,
      };

      const response = await AxiosService.post<
        tLeadbotChatbotResponse,
        tLeadbotResponse<{ data: tCreateLeadbotResponse }>
      >(`/chatbot/${wid}/chat-bot`, formData, config);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  updateLeadbotStatus: async function (
    wid: string,
    chatbotId: string,
    active: boolean,
  ): Promise<tLeadbotResponse<{ data: tUpdateLeadbotStatusResponse }>> {
    try {
      const config: tAxiosCustomConfig = {
        headers: {},
        isLegacy: true,
      };

      const response = await AxiosService.patchById<
        tUpdateLeadbotStatusResponse,
        tLeadbotResponse<{ data: tUpdateLeadbotStatusResponse }>
      >(`/chatbot/${wid}/chat-bot`, chatbotId, { active: active }, config);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  deactivateAllAutomations: async function (
    workspaceId: string,
    automations: tAutomationsResponse[],
  ): Promise<void> {
    const updateChatbotAction = httpsCallable(firebase.functions, 'updateChatbotAction');
    const activeAutomations = automations.filter((a) => a.active);
    await Promise.all(
      activeAutomations.map((automation) =>
        updateChatbotAction({
          id: automation.id,
          workspaceID: workspaceId,
          type: automation.type,
          message: automation.message,
          expectsResponse: false,
          active: false,
        }),
      ),
    );
  },
};
